import React from 'react';

export const CrossIcon = () => (
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.927734 7.91473L7.99973 0.844727M0.927734 0.844727L7.99973 7.91473"
      stroke="#999999"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);
